<template>
  <div>
    <!----------Header Section ------------>
    <div class="border-bottom primary-header desktop-view-header">
      <b-container id="element">
        <b-row style="flex-wrap: nowrap">
          <b-col md="3" class="d-flex justify-content-start align-items-center">
            <div class="logo">
              <a
                href="/"
                v-if="modules.home"
                @click="() => updateWebsiteMode('product')"
              >
                <img src="img/navbar/logo.png" />
              </a>
            </div>
          </b-col>
          <b-col>
            <div class="search-mobile-view mt-2">
              <template v-if="$options.components['search-bar']">
                <search-bar />
              </template>
            </div>
          </b-col>
          <b-col
            class="d-flex justify-content-start align-items-center"
            v-if="showNavItems"
          >
            <h5
              class="font-16 ml-3 mt-2 cursor-pointer font-weight-bold text-black"
              @click="$router.push('/')"
            >
              {{ $t("home") }}
            </h5>
            <h5
              class="font-16 ml-3 mt-2 cursor-pointer font-weight-bold text-black"
              @click="$router.push('/about')"
            >
              {{ $t("about") }}
            </h5>
            <h5
              class="font-16 ml-3 mr-4 mt-2 cursor-pointer font-weight-bold text-black"
              @click="$router.push('/contact')"
            >
              {{ $t("contact") }}
            </h5>
          </b-col>

          <b-col md="2" class="d-flex justify-content-end align-items-center">
            <ul class="list-unstyled heartbagUl mb-0" style="cursor: pointer">
              <li class="ml-2" v-if="showChatIcon">
                <b-dropdown
                  right
                  no-caret
                  variant="link"
                  toggle-class="p-0"
                  class="chat-dropdown"
                >
                  <template #button-content>
                    <div class="icon-wrapper">
                      <b-iconstack>
                        <b-icon icon="chat-left-text" variant="black"></b-icon>
                      </b-iconstack>
                    </div>
                  </template>
                  <div
                    class="primary-header"
                    v-for="(seller, index) in chatSellerList"
                    :key="index"
                  >
                    <b-dropdown-item
                      @click="() => openChatPopup(seller)"
                      class="drop-list"
                    >
                      <b-icon icon="person-circle" class="mr-2"></b-icon>
                      {{ seller.sellerName }}
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </li>
              <li class="ml-2" v-if="showWishlistIcon">
                <div class="wishlist-header">
                  <router-link
                    :to="{ path: '/wishlist' }"
                    class="wishlist-link"
                  >
                    <div class="icon-wrapper">
                      <b-iconstack>
                        <b-icon icon="heart" variant="black"></b-icon>
                      </b-iconstack>
                      <h6
                        v-if="listData.length > 0"
                        class="wishlist-notification"
                      >
                        {{ wishlistItemCount }}
                      </h6>
                    </div>
                  </router-link>
                </div>
              </li>
              <li v-if="showCartIcon">
                <div class="header-cart">
                  <b-iconstack class="pointer" @click="toggleCart">
                    <b-icon icon="bag" variant="black"></b-icon>
                  </b-iconstack>
                  <SliderCart
                    :isVisible="isCartVisible"
                    @toggle-cart="toggleCart"
                  />
                  <h6 v-if="cartData.length > 0" class="checkout-notification">
                    {{ cartItemCount }}
                  </h6>
                </div>
              </li>
              <li>
                <div>
                  <b-button
                    v-if="!$store.state['auth'].isLoggedin"
                    @click="
                      () =>
                        this.$router.push({
                          name: 'login with',
                        })
                    "
                    variant="primary"
                    >{{ $t("login") }}</b-button
                  >
                  <div
                    v-else
                    class="header-loginsec user-name d-flex align-items-center"
                  >
                    <!-- Welcome Text -->
                    <span class="mr-2 text-dark font-16 font-weight-bold">
                      <template v-if="!$store.state['auth'].isLoggedin">
                        {{ $t("hello") }}
                      </template>
                      <template v-else>
                        {{
                          userInfo.name.first && userInfo.name.first.length > 6
                            ? userInfo.name.first.substring(0, 6) + "..."
                            : userInfo.name.first
                        }}
                      </template>
                    </span>
                    <b-dropdown
                      :class="
                        Object.keys(themeColor).length !== 0
                          ? 'dropdown-toggle-new'
                          : ''
                      "
                      class="profile-dropdown"
                      id="dropdown-1"
                    >
                      <template #button-content>
                        <b-iconstack>
                          <b-icon icon="person" variant="black"></b-icon>
                        </b-iconstack>
                      </template>
                      <b-dropdown-item
                        @click="$router.push('/profile')"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/profile.png" />
                        <span class="text-dark ml-2">{{ $t("profile") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="myOrder"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/order.png" />
                        <span class="text-dark ml-2">
                          {{ $t("myorders") }}</span
                        >
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="$router.push('/wishlist')"
                        v-if="!showWishlistIcon"
                      >
                        <img class src="img/navbar/wishlist.png" />
                        <span class="text-dark ml-2">{{
                          $t("mywishlist")
                        }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="$router.push('/checkout')"
                        v-if="!showCartIcon"
                      >
                        <img style="width: 19px" src="img/navbar/Bag.png" />
                        <span class="text-dark ml-2">{{ $t("mycart") }} </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="logout"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/logout.png" />
                        <span class="text-dark ml-2">{{ $t("logout") }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="primary-header mobile-view-header">
      <b-container fluid id="element">
        <b-row>
          <b-col sm="12">
            <div class="d-flex justify-content-between align-items-center">
              <b-icon
                v-if="!showMobileMenu"
                icon="list"
                scale="2"
                class="ml-1 direct-class"
                variant="dark"
                @click="viewMobileMenu"
              />
              <b-icon
                v-if="showMobileMenu"
                icon="x"
                scale="2.7"
                class="ml-1 direct-class"
                variant="dark"
                @click="hideMobileMenu"
              />
              <div class="logo">
                <a
                  href="/"
                  v-if="modules.home"
                  @click="() => updateWebsiteMode('product')"
                >
                  <img src="img/navbar/logo.png" />
                </a>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="header-cart" v-if="showCartIcon">
                  <button @click="toggleCart">
                    <img src="img/navbar/Bag.png" alt="" />
                  </button>
                  <SliderCart
                    :isVisible="isCartVisible"
                    @toggle-cart="toggleCart"
                  />
                  <h6 v-if="cartData.length > 0" class="checkout-notification">
                    {{ cartItemCount }}
                  </h6>
                </div>
                <div class="forMobileProfile">
                  <b-button
                    v-if="!$store.state['auth'].isLoggedin"
                    @click="() => this.$router.push({ name: 'login' })"
                    variant="primary"
                    >{{ $t("login") }}</b-button
                  >
                  <div
                    v-else
                    class="header-loginsec user-name d-flex align-items-center"
                  >
                    <!-- Welcome Text -->
                    <span class="mr-2 text-dark font-16 font-weight-bold">
                      <template v-if="!$store.state['auth'].isLoggedin">
                        {{ $t("hello") }}
                      </template>
                      <template v-else>
                        {{
                          userInfo.name.first && userInfo.name.first.length > 6
                            ? userInfo.name.first.substring(0, 6) + "..."
                            : userInfo.name.first
                        }}
                      </template>
                    </span>
                    <b-dropdown
                      :class="
                        Object.keys(themeColor).length !== 0
                          ? 'dropdown-toggle-new'
                          : ''
                      "
                      id="dropdown-1"
                    >
                      <template #button-content>
                        <b-iconstack>
                          <b-icon icon="person" variant="black"></b-icon>
                        </b-iconstack>
                      </template>
                      <b-dropdown-item
                        @click="$router.push('/profile')"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/profile.png" />
                        <span class="text-dark ml-2">{{ $t("profile") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="myOrder"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/order.png" />
                        <span class="text-dark ml-2">{{ $t("myorders") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="logout"
                        class="d-flex align-items-center"
                      >
                        <img src="img/navbar/logout.png" />
                        <span class="text-dark ml-2">{{ $t("logout") }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <transition name="fade-slide">
                <div class="menu-mobile-view" v-if="showMobileMenu">
                  <h5
                    class="font-16 mb-3 cursor-pointer"
                    @click="
                      showMobileMenu = false;
                      $router.push('/');
                    "
                  >
                    {{ $t("home") }}
                  </h5>
                  <h5
                    class="font-16 mb-3 cursor-pointer"
                    @click="
                      showMobileMenu = false;
                      $router.push('/about');
                    "
                  >
                    {{ $t("about") }}
                  </h5>
                  <h5
                    class="font-16 mb-3 cursor-pointer"
                    @click="
                      showMobileMenu = false;
                      $router.push('/profile');
                    "
                    v-if="isLoggedin"
                  >
                    {{ $t("footer.myAccount") }}
                  </h5>
                  <h5
                    class="font-16 mb-3 cursor-pointer"
                    @click="
                      showMobileMenu = false;
                      $router.push('/contact');
                    "
                  >
                    {{ $t("contact") }}
                  </h5>
                  <b-button
                    v-if="!$store.state['auth'].isLoggedin"
                    @click="
                      showMobileMenu = false;
                      this.$router.push({ name: 'login' });
                    "
                    variant="primary"
                    >{{ $t("login") }}</b-button
                  >
                </div>
              </transition>
            </template>
          </b-col>
        </b-row>
        <b-modal
          id="bv-modal-chat-option"
          size="lg"
          :title="sellerDetails?.pid?.authentication?.userName || 'Seller Chat'"
          :hide-footer="true"
          :hide-header="false"
          :no-close-on-esc="true"
          :no-close-on-backdrop="true"
          centered
          header-class="my-class"
          body-class="p-0"
        >
          <ChatBox :sellerDetails="sellerDetails"></ChatBox>
        </b-modal>
      </b-container>
    </div>
    <!----------- Slot ---------------->
    <b-container fluid class="p-0 mobile-hide-margin slot-container">
      <slot></slot>
    </b-container>

    <chatbot-chatbot />
    <!------------footer section ---------->

    <div class="footer-bg">
      <b-container>
        <b-row>
          <b-col md="12">
            <div class="footer_content">
              <h5
                class="font-16 mb-3 cursor-pointer"
                @click="$router.push('/')"
              >
                {{ $t("home") }}
              </h5>
              <h5
                class="font-16 mb-3 cursor-pointer"
                @click="$router.push('/about')"
              >
                {{ $t("about") }}
              </h5>
              <h5
                class="font-16 mb-3 cursor-pointer"
                @click="$router.push('/profile')"
                v-if="isLoggedin"
              >
                {{ $t("footer.myAccount") }}
              </h5>
              <h5
                class="font-16 mb-3 cursor-pointer"
                @click="$router.push('/contact')"
              >
                {{ $t("contact") }}
              </h5>
            </div>
            <hr class="mt-2 hr-1" />
            <div
              class="copyrightSec d-flex justify-content-center align-items-center pb-2"
            >
              <p class="mb-0 font-14 font-weight-bold">
                {{ appName }} © {{ new Date().getFullYear() }}
                {{ $t("footer.copyright") }}. Powered by
                <a href="https://fastforge.ai/" target="_blank">FastForge</a>
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container class="mobileMenuSec">
      <b-row>
        <b-col md="12">
          <div class="teka-mobile-menu">
            <router-link to="/">
              <b-icon icon="house-door"></b-icon>
              {{ $t("home") }}
            </router-link>
            <router-link to="/my-order">
              <b-icon icon="cart4"></b-icon>
              <span class="text-center">{{ $t("myorders") }}</span>
            </router-link>
            <router-link to="/profile">
              <b-icon icon="person-circle"></b-icon>{{ $t("footer.myAccount") }}
            </router-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import SliderCart from "../modules/checkout/components/slider-cart.vue";
import config from "/public/config.json";
import ChatBox from "../modules/home/components/chatBox.vue";
export default {
  name: "layout",
  components: {
    SliderCart,
    ChatBox,
  },
  data() {
    return {
      appName: config.appName,
      isCartVisible: false,
      selectedLanguage: "en",
      isLoading: false,
      showMobileMenu: false,
      sellerDetails: {},
    };
  },
  computed: {
    ...mapGetters({
      modules: "availableModules",
    }),
    ...mapState({
      listData: (state) => state.wishlist.listData,
      cartData: (state) => state.checkout.cartData,
      themeColor: (state) => state.theme.themeColor,
      userInfo: (state) => state.auth.userInfo,
      currentPosition: (state) => state.location.currentPosition,
      partnerInfo: (state) => state.shopDetails.partnerInfo,
      language: (state) => state.home.language,
      tenantConfig: (state) => state.home.tenantConfig,
      isLoggedin: (state) => state.auth.isLoggedin,
      chatList: (state) => state.home.chatList,
    }),
    chatSellerList() {
      return this.chatList
        .map((chatItem) => {
          if (!chatItem.pid) return null;
          return {
            sellerName: chatItem.pid.authentication.userName,
            sellerId: chatItem.pid._id,
          };
        })
        .filter(Boolean);
    },
    showChatIcon() {
      // return this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerCartIcon
      //   ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerCartIcon
      //   : false;
      return this.chatList.length > 0;
    },
    showCartIcon() {
      // return this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerCartIcon
      //   ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerCartIcon
      //   : false;
      return true;
    },
    showWishlistIcon() {
      // return this.tenantConfig?.buildConfig?.web?.dynamicFields
      //   ?.headerWishlistIcon
      //   ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerWishlistIcon
      //   : false;
      return true;
    },
    showNavItems() {
      // return this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerNavs
      //   ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.headerNavs
      //   : false;
      return true;
    },
    cartItemCount() {
      if (Array.isArray(this.cartData) && this.cartData.length > 0) {
        let arr = [];
        this.cartData.forEach((item) => {
          if (item._id !== "67f0bd1458eeb6f746342b34") arr.push(item);
        });
        return arr.length;
      } else {
        return 0;
      }
    },
    wishlistItemCount() {
      if (Array.isArray(this.listData) && this.listData.length > 0) {
        return this.listData.length;
      } else {
        return 0;
      }
    },
    // headerGradient() {
    //   return {
    //     background: `#FFF`,
    //   };
    // },
  },
  methods: {
    ...mapActions({
      fetchWishlist: "wishlist/listWishList",
    }),
    openChatPopup(seller) {
      this.sellerDetails = this.chatList.find(
        (item) => item.pid._id === seller.sellerId,
      );
      this.$bvModal.show("bv-modal-chat-option");
    },
    async fetchTenantPrefernces() {
      try {
        this.$store.dispatch(
          "home/fetchTenantPreference",
          process.env.VUE_APP_TENANT,
        );
        this.$store.dispatch(
          "home/fetchPaymentConfig",
          process.env.VUE_APP_TENANT,
        );
        this.$store.dispatch("home/fetchTenantConfig");
        this.$store.dispatch(
          "home/fetchTenantDetails",
          process.env.VUE_APP_TENANT,
        );
      } catch (error) {
        console.error("Failed to fetch language:", error);
      }
    },
    toggleCart() {
      this.$router.push("/checkout");
    },
    viewMobileMenu() {
      this.showMobileMenu = true;
    },
    hideMobileMenu() {
      this.showMobileMenu = false;
    },
    async myOrder() {
      await this.$store.dispatch("profile/fetchOrderList");
      this.$router.push("/my-order");
    },
    updateWebsiteMode(payload) {
      this.selected = payload;
      this.$store.dispatch("core/setWebsiteMode", payload);
      this.$router.push("/");
    },
    async fetchCart() {
      if (Array.isArray(this.cartData) && this.cartData.length == 0)
        await this.$store.dispatch("checkout/fetchCartData", {
          shipFrom: "US",
          shipTo: "US",
          country: "US",
        });
      this.isLoading = false;
    },
    logout() {
      this.$bvModal
        .msgBoxConfirm(
          this.$t("logoutConfirm.message", { appName: this.appName }),
          {
            title: this.$t("logoutConfirm.title"),
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("logoutConfirm.ok"),
            cancelTitle: this.$t("logoutConfirm.cancel"),
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            this.showMobileMenu = false;
            localStorage.removeItem(
              `${process.env.VUE_APP_TENANT}:access_token`,
            );
            localStorage.removeItem(`${process.env.VUE_APP_TENANT}:userInfo`);
            localStorage.removeItem(
              `${process.env.VUE_APP_TENANT}:address_popup`,
            );
            this.$store.dispatch("auth/resetUser");
            this.$store.dispatch("checkout/resetCartData");
            this.$swal({
              text: this.$t("swal.seeYou"),
              type: "success",
              title: this.$t("wishlistProduct.successTitle"),
              timer: 1100,
            });
            if (this.$route.fullPath !== "/")
              this.$router.push({ name: "Home" });
          }
        });
    },
  },
  async mounted() {
    this.isLoading = true;
    this.$store.dispatch("home/fetchStoreDetails", {
      tenant: process.env.VUE_APP_TENANT,
    });
    await this.fetchTenantPrefernces();
    if (this.$store.state["auth"].isLoggedin) await this.fetchCart();
    if (this.$store.state["auth"].isLoggedin) await this.fetchWishlist();
    // this.$nextTick(() => {
    //   this.$nuxt.$loading.start();
    //   setTimeout(() => this.$nuxt.$loading.finish(), 3000);
    // });
    if (this.language?.defaultLanguage) {
      this.$i18n.locale = this.language.defaultLanguage;
    }
    this.$store.dispatch("home/fetchChatList");
  },
};
</script>
<style>
.select-style .custom-select {
  border-radius: 50px;
  height: 43px;
  margin-left: -10px;
  width: 120px;
  font-size: 0.8125rem;
  color: #bbbbbb;
}

.dropdown-item {
  padding: 0.25rem 0.875rem;
}

.dropdown-toggle-new :after {
  color: black;
}

.knowsus a {
  display: block;
  margin-bottom: 15px;
  color: #fff;
}

#dropdown-1 .dropdown-toggle::after {
  display: none;
}

.knowsus a:hover {
  color: var(--primarycolor);
  text-decoration: none;
}

.header-PS {
  border: 1px solid #fff;
  border-radius: 3px;
}

.playstore-div {
  margin-top: 15px;
}

.playstore-div li {
  list-style: outside none none;
}

.playstore-div li p {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 15px;
}

.primary-header {
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
  position: sticky;
  color: #fff;
  /*top: 34px;*/
  z-index: 8;
  width: 100%;
  /* display: block; */
  clear: both;
}

.topHeader {
  background: #fff;
  /* /* display: block; */
  border-bottom: 1px solid #979797;
  width: 100%;
  top: 0;
  z-index: 8;
  position: sticky;
}

.header-loginsec {
  margin-left: 15px;
}

.heartbagUl {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.heartbagUl > li {
  margin-right: 20px;
}

.heartbagUl li:last-child {
  margin-right: 0;
}

.heartbagUl .b-icon {
  font-size: 1.25rem !important;
}

.header-loginsec button {
  padding-top: 0;
  padding-left: 0;
}

.topEngOption .btn {
  font-size: 0.8125rem;
  font-weight: 400;
}

.topEngOption .btn:hover {
  text-decoration: none;
}

.topPhone {
  font-size: 0.8125rem;
  color: #000;
}

.topPhone:hover {
  text-decoration: none;
}

.topPhone .b-icon {
  width: 16px;
  color: #000 !important;
}

@media (max-width: 768px) {
  .topHeader {
    height: auto;
    padding: 10px 15px;
  }

  .topHeader .d-flex {
    display: flex;
    flex-wrap: nowrap !important;
    justify-content: space-between;
    align-items: center;
  }

  .topHeader .b-col {
    padding-left: 0;
    padding-right: 0;
  }

  .topHeader .b-dropdown {
    font-size: 0.875rem;
  }

  .topHeader .me-3 {
    margin-right: 10px;
  }

  .topHeader .align-items-center {
    align-items: center;
  }
}

.location-icon {
  color: #6c757d;
  /* Icon color */
}

.store-location {
  font-size: 0.875rem;
  color: #6c757d;
  /* Subtle gray */
}

#dropdown-language,
#dropdown-currency {
  font-size: 0.875rem;
  color: #6c757d;
}

.margin-top {
  margin-top: 30px;
}

.top-header-leftside {
  margin-bottom: 0;
  padding: 20px 0;
  margin-top: 8px;
}

.top-header-rightside {
  padding: 27px 0;
  margin-bottom: 0;
  text-align: center;
}

.top-header-rightside > li {
  list-style: outside none none;
  display: inline-block;
  margin-right: 10px;
}

.top-header-rightside > li:last-child {
  margin-right: 0 !important;
}

.available-onsec {
  text-align: center;
  font-size: 0.8125rem;
}

.top-header-leftside li {
  list-style: outside none none;
  display: inline-block;
  margin-right: 25px;
}

.android-iphone-icon {
  margin-top: 2px;
}

.top-header-leftside li:last-child {
  margin-right: 0 !important;
}

.height {
  height: 30px !important;
}

#link-footer {
  color: #fff;
  text-decoration: none;
}

.header-cart {
  position: relative;
}

.checkout-notification {
  background: var(--primarycolor);
  position: absolute;
  top: -10px;
  right: -20px;
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50px;
  margin: 0;
  font-size: 0.875rem;
}

#btn-radios-2 {
  height: 36px !important;
}
.icon-wrapper {
  position: relative;
  display: inline-block;
}

.wishlist-notification {
  position: absolute;
  top: -11px;
  right: -20px;
  background-color: red;
  color: white;
  font-size: 0.875rem;
  padding: 2px 5px;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  min-width: 25px;
  text-align: center;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1191px) {
  .wishlist-notification {
    background: var(--primarycolor);
    position: absolute;
    top: 3px;
    left: 3px;
    height: 18px;
    width: 18px;
    text-align: center;
    line-height: 18px;
    border-radius: 50px;
    margin: 0;
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .wishlist-notification {
    left: 0;
    top: 0;
    height: 20px;
    width: 20px;
    line-height: 20px;
    font-size: 0.75rem;
  }
}

.teka-mobile-menu {
  padding: 8px 10px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 3;
  background: #fff;
  border-radius: 10px 10px 0px 0px;
  -webkit-box-shadow: 0px -5px 15px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px -5px 15px 0px rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: none;
}

.teka-mobile-menu a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 80px;
  padding: 8px 0px;
  border-radius: 8px;
  position: relative;
  color: #272727;
  font-size: 0.875rem;
}

.mobile-view-header {
  display: none;
}

.teka-mobile-menu a.router-link-exact-active.router-link-active {
  color: var(--primarycolor);
}

.market-width {
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  padding-bottom: 20px;
}

.footer-makeinindia img {
  background: #fff;
  padding: 5px;
}

.checkout-notification {
  background: var(--primarycolor);
}
.wishlist-notification {
  background: var(--primarycolor);
}

.nipigeTextColor {
  color: var(--darkcolor);
}

.logo img {
  width: 100%;
  max-width: 90px;
  max-height: 70px;
  object-fit: cover;
}

@media (max-width: 1191px) {
  .checkout-notification {
    background: var(--primarycolor);
    position: absolute;
    top: 3px;
    right: -3px;
    height: 18px;
    width: 18px;
    text-align: center;
    line-height: 18px;
    border-radius: 50px;
    margin: 0;
    font-size: 0.75rem;
  }

  .top-header-rightside {
    padding: 0;
  }

  .desktop-view-header {
    display: none;
  }

  .mobile-view-header {
    display: block;
    position: sticky;
    border-bottom: 1px solid #dddd;
    box-shadow: 0 0px 8px #ddd;
  }

  .payment-method-footer {
    text-align: left !important;
  }

  .margin-top-2 {
    background: linear-gradient(var(--primarycolor), var(--darkcolor));
  }

  .teka-mobile-menu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .margin-top-98.mobile-hide-margin {
    margin-top: 0 !important;
  }

  .copyright-sec {
    margin-bottom: 60px;
  }

  #helpContent {
    display: none;
  }

  /* .footer-part{
    display: none;
  } */
}

.market-width {
  margin-left: 9px;
  text-align: left;
}

.footer-bg {
  background: var(--secondary);
  color: var(--secondarydark);
}
.cart-icon {
  color: var(--darkcolor) !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* .rectangle-card {
  position: absolute;
  left: 85.07%;
  right: 4.24%;
  top: 0.32%;
  bottom: 98.01%;
  background: #ea6d00;
  border-radius: 24px;
} */
.btn-outline-primary:not(:disabled):not(.disabled):active {
  background-color: var(--darkcolor) !important;
}

.custom-radio-button .btn:focus,
.custom-radio-button .btn.focus {
  outline: none;
  box-shadow: none;
  /* Optional: also remove the box-shadow if it exists */
}

.list-unstyled {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-unstyled a {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.list-unstyled a:hover {
  color: var(--primarycolor);
  text-decoration: none;
}

.footer_content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  font-weight: 700;
  padding-top: 20px;
  padding-bottom: 10px;
}

.slot-container {
  min-height: calc(100vh - 230px);
}

/* .router-link-active {
  color: #007bff;
  text-decoration: underline;
} */
.mobileMenuSec {
  display: none;
}

.profile-dropdown .dropdown-menu.show {
  transform: translate3d(-70px, 30px, 0px) !important;
}

@media (max-width: 1200px) {
  .dropdown-menu.show {
    transform: translate3d(-130px, 30px, 0px) !important;
  }

  .header-cart {
    margin-right: 5px;
  }

  .footer_content {
    gap: 2rem;
    padding-top: 2px;
  }

  .heartbagUl li {
    margin-right: 10px;
  }

  .mobileMenuSec {
    display: block;
  }

  .footer_content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .copyrightSec {
    padding-bottom: 3rem;
  }
}

@media (max-width: 991px) {
  .primary-header .b-col {
    padding: 10px;
  }

  .footer_content {
    flex-wrap: wrap;
    gap: 1.5rem;
    justify-content: space-around;
  }
}

@media (max-width: 768px) {
  .slot-container {
    min-height: calc(100vh - 280px);
  }

  .copyrightSec {
    padding-bottom: 0;
  }

  .footer-bg {
    padding-bottom: 2.5rem;
    padding-top: 1rem;
  }

  .primary-header {
    padding: 10px 0;
  }

  .logo img {
    max-width: 70px;
    max-height: 70px;
  }

  .heartbagUl {
    margin: 10px 0;
  }
}

@media (max-width: 576px) {
  .container {
    padding: 0 15px;
  }

  .checkout-notification {
    right: -10px;
    height: 20px;
    width: 20px;
    line-height: 20px;
    font-size: 0.75rem;
  }

  .teka-mobile-menu a {
    width: 60px;
    font-size: 0.75rem;
  }
}

.custom-radio {
  z-index: 0 !important;
}

.direct-class {
  cursor: pointer;
}

.menu-mobile-view {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  background: var(--secondarydark);
  opacity: 0.95;
  width: 104%;
  position: absolute;
  padding: 15px;
  top: 88%;
  left: -3px;
  z-index: 1000;
  height: 100vh;
  gap: 12px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateX(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
